import '../scss/styles.scss'
import '../scss/feedback.scss'
import { BirmePDF } from './BirmePDF.js'
import { initFeedbackForm } from './feedback.js'

declare global {
  interface Window {
    pdfTool: BirmePDF
  }
}

window.pdfTool = new BirmePDF()
initFeedbackForm()
